<template>
	<div>
    <MainNavigation></MainNavigation>
    <Hero></Hero>

    <router-view></router-view>
    
	</div>
</template>

<script>
import Hero from './components/Hero/Hero.vue';
import Footer from './components/Footer/Footer.vue';
import MainNavigation from './components/MainNavigation/MainNavigation.vue';
export default {

	mounted: function() {
    this.$store.dispatch('fetchSlides');
	},
	data() {
		return {
		};
	},
  components: {
    MainNavigation,
    Hero,
    Footer
  }

};
</script>

